import { render, staticRenderFns } from "./PainelGestaoProdutos.vue?vue&type=template&id=5a869369"
import script from "./PainelGestaoProdutos.vue?vue&type=script&lang=js"
export * from "./PainelGestaoProdutos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports